import './Navbar.css'
import React, { useState  } from 'react'
import { Link, useNavigate } from 'react-router-dom'

export default function Navbar() {

  const [searchText, setSearchText] = useState("")
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("userData"));

  const [showProfile, setShowProfile] = useState(false);

  const handleSubmit = (e)=>{
    e.preventDefault();
    navigate(`/all-movies?searchQuery=${searchText}`);
  }

  const handleLogout = ()=>{
    localStorage.removeItem("userData");
    setShowProfile(false)
  }

  return (
    <>
    {(showProfile) && <div className="profileContainer">
      
      <div className="profile">
        <i className='fa-solid fa-circle-user'></i>
      </div>
      <div className="userInfo">
      <div className="close" onClick={()=>{setShowProfile(false)}}>
        <i className='fa-solid fa-close'></i>
      </div>
        <div className="name"><i className="fa-solid fa-signature"></i>
        &nbsp; {userData.username}</div>
        <div className="name"> <i className='fa-solid fa-envelope'></i> 
        &nbsp; {userData.email}</div>
        <div className="name"> <i className='fa-solid fa-phone'></i>
        &nbsp; {userData.phone}</div>
        <button className="logoutBtn" onClick={handleLogout}>
        <i className="fa-solid fa-right-from-bracket"></i> Logout</button>
      </div>
    </div>}

    {/* Navbar component starts from here.... */}
    <div className='navbar-container'>
      <div className="navleft">
        <Link to="/" className='link'>
          <div className="logoName">
              <div className="logo">
                  <img width="40" height="40" src="https://img.icons8.com/stickers/40/movie-projector.png" alt="movie-projector"/>
              </div>
              <div className="name">Show box</div>
          </div>
        </Link>
        <div className="search-container">
            <form onSubmit={handleSubmit}>
              <input type="search"
              value ={searchText}
              onChange={(e)=>{setSearchText(e.target.value)}}
              className="search" placeholder='Search for movies ...' />
              <button className="search-btn">
                  <i className="fa-solid fa-magnifying-glass"></i>
              </button>
            </form>
        </div>
      </div>

      <div className="navright">
          <Link className='alink' to={'/all-movies'}>
            <span className="navlink">
              <i className="fa-solid fa-film icon"></i>&nbsp; All Movies
            </span>
          </Link>
          { (userData &&  userData.usertoken) ? 
          <div className="profile" onClick={()=>{setShowProfile(true)}}>
            <i className='fa-solid fa-circle-user'></i>
          </div> :  <Link to='/login'>
            <button className="login-btn">Login</button>
          </Link>}
      </div>


    </div>
    <div className="res-search-container">
      <form onSubmit={handleSubmit}>
        <input type="search"
        value ={searchText}
        onChange={(e)=>{setSearchText(e.target.value)}}
        className="search" placeholder='Search for movies ...' />
        <button className="search-btn">
            <i className="fa-solid fa-magnifying-glass"></i>
        </button>
      </form>
    </div>
    </>
  )
}
